import { render, staticRenderFns } from "./ViewButton.vue?vue&type=template&id=59821798&lang=pug&"
import script from "./ViewButton.vue?vue&type=script&lang=js&"
export * from "./ViewButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports